import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { apiFetch } from '../lib/api'

interface Worker {
  id: string
  email: string
  name: string
  trade: string
  subscription_tier: string
  cscs_status: string
  created_at: string
}

export function Workers() {
  const [workers, setWorkers] = useState<Worker[]>([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')

  useEffect(() => {
    fetchWorkers()
  }, [])

  async function fetchWorkers() {
    try {
      const data = await apiFetch('/api/admin/workers')
      setWorkers(data.workers || [])
    } catch {}
    setLoading(false)
  }

  const filtered = workers.filter(w =>
    w.name?.toLowerCase().includes(search.toLowerCase()) ||
    w.email?.toLowerCase().includes(search.toLowerCase()) ||
    w.trade?.toLowerCase().includes(search.toLowerCase())
  )

  if (loading) return <div className="loading">Loading workers...</div>

  return (
    <div className="page">
      <header className="page-header">
        <h1>Workers</h1>
        <p>{workers.length} registered workers</p>
      </header>

      <div className="toolbar">
        <input
          type="text"
          placeholder="Search by name, email, or trade..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Trade</th>
              <th>Tier</th>
              <th>CSCS</th>
              <th>Joined</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(worker => (
              <tr key={worker.id}>
                <td>
                  <Link to={`/workers/${worker.id}`} className="link">
                    {worker.name || 'Not set'}
                  </Link>
                </td>
                <td>{worker.email}</td>
                <td>{worker.trade || 'Not set'}</td>
                <td><span className="badge">{worker.subscription_tier}</span></td>
                <td>
                  <span className={`status-badge ${worker.cscs_status}`}>
                    {worker.cscs_status}
                  </span>
                </td>
                <td>{new Date(worker.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
